@if (previewUrl()) {
    <div class="preview-container">
        <img [src]="previewUrl()" alt="" class="preview-image" />
        <div class="preview-overlay">
            <button #updateButton type="button" class="update-button" (click)="updateFile()" [disabled]="disabled()">
                <i class="dx-icon-photo"></i>
                <dx-tooltip [target]="updateButton">
                    <div *dxTemplate="let data of 'content'">
                        {{ 'updateImage' | transloco }}
                    </div>
                </dx-tooltip>
            </button>
            @if (removable()) {
                <button #removeButton type="button" class="remove-button" (click)="removeFile()" [disabled]="disabled()">
                    <i class="dx-icon-close"></i>
                    <dx-tooltip [target]="removeButton">
                        <div *dxTemplate="let data of 'content'">
                            {{ 'removeImage' | transloco }}
                        </div>
                    </dx-tooltip>
                </button>
            }
        </div>
    </div>
}

<div
    #uploader
    class="form-photo-uploader__drop-zone"
    [tabindex]="disabled() ? -1 : 0"
    [style.height]="height() + 'px'"
    [style.display]="previewUrl() ? 'none' : 'flex'"
    [style.visibility]="previewUrl() ? 'hidden' : 'visible'"
    [style.position]="previewUrl() ? 'absolute' : 'relative'"
    [class.dx-theme-accent-as-border-color]="isDropZoneActive()"
    [class.dx-theme-border-color]="!isDropZoneActive()"
    [class.disabled]="disabled()"
    [style.pointer-events]="disabled() ? 'none' : 'auto'"
    [style.opacity]="disabled() ? '0.6' : '1'"
>
    <span>{{ placeholder() | transloco }}</span>
</div>

<dx-file-uploader
    #fileUploader
    class="form-photo-uploader__dx form-photo-uploader__dx--photo"
    [class.is-uploading]="isUploading()"
    [multiple]="false"
    [accept]="validFormats()"
    [allowedFileExtensions]="allowedExtensions()"
    uploadMode="instantly"
    [showFileList]="true"
    name="file"
    [uploadUrl]="uploadUrl"
    [chunkSize]="100000"
    [disabled]="disabled()"
    (onDropZoneEnter)="onDropZoneEnter($event)"
    (onDropZoneLeave)="onDropZoneLeave($event)"
    (onValueChanged)="onValueChanged($event)"
    (onUploadStarted)="onUploadStarted()"
    (onUploaded)="onUploaded($event)"
    (onUploadError)="onUploadError()"
>
</dx-file-uploader>
